<div class="col-xl">
    <form (ngSubmit)="enviar()" class="card p-4">
        <h2 class="mb-4">Checklist general</h2>

        <!-- Datos de la unidad -->
        <div class="card-body row">
            <div class="mb-0 p-1 border rounded">
                <div class="card-header mt-0 d-flex justify-content-between align-items-center">
                    <h4 class="mb-0">Datos de la unidad</h4>
                </div>
                <div class="card-body row">

                    <div class="row">
                        <div class="col-md-4">
                            <label class="switch-label">Usuario</label><br>
                            <span>{{dataUser.name}}</span>
                        </div>
                        <div class="col-md-4">
                            <label class="switch-label">Unidad</label><br>
                            <span>{{unit.unit}}</span>
                        </div>
                        <div class="col-md-4">
                            <label class="switch-label">Placas</label><br>
                            <span>{{unit.plates}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Motor -->
        <div class="card-header d-flex justify-content-between align-items-center">
            <h4 class="mb-0">Motor</h4>
        </div>

        <div class="card-body row">
            <div class="mb-0 p-3 border rounded">
                <div class="row">
                    <ng-container *ngFor="let campo of [
                    {nombre:'oil_level', label:'Nivel de aceite correcto'},
                    {nombre:'oil_leaks', label:'Sin fugas de aceite visibles'},
                    {nombre:'antifreeze_level', label:'Nivel de anticongelante correcto'},
                    {nombre:'hoses_in_good_condition', label:'Mangueras en buen estado (sin fugas ni grietas)'},
                    {nombre:'water_pump', label:'Bomba de agua sin fugas'},
                    {nombre:'correas_in_good_condition', label:'Bandas en buen estado (sin grietas o desgaste)'},
                    {nombre:'battery_correct', label:'Batería sin sulfatación, fija y conectada correctamente'}
                ]">
                        <div class="col-md-4 mb-3">
                            <label class="switch-label">{{campo.label}}</label>
                            <div class="input-group input-group-merge">
                                <label class="switch switch-lg">
                                    <input type="checkbox" [(ngModel)]="data[campo.nombre]" class="switch-input"
                                        [name]="campo.nombre" (ngModelChange)="onFormDataChange()" />
                                    <span class="switch-toggle-slider">
                                        <span class="switch-on">
                                            Si
                                        </span>
                                        <span class="switch-off">
                                            No
                                        </span>
                                    </span>
                                    <!-- <span class="switch-label">{{campo.label}}</span> -->
                                </label>
                            </div>
                        </div>
                    </ng-container>
                </div>
                <div class="row">
                    <div class="col-12">
                        <input type="file" #evidenceInputEngine multiple class="d-none" accept="image/*" capture="environment"
                            (change)="onFileChange($event, 'engine')">
                        <input type="file" #evidenceInputEngineGallery multiple class="d-none" accept="image/*"
                            (change)="onFileChange($event, 'engine')">
                        <a class="upload_file d-none d-lg-block" (click)="$event.preventDefault(); evidenceInputEngineGallery.click();">Subir evidencia del motor</a>
                        <div class="d-flex gap-2 flex-wrap d-lg-none">
                            <a class="upload_file" (click)="$event.preventDefault(); evidenceInputEngine.click();">Tomar foto</a>
                            <!-- <a class="upload_file" (click)="$event.preventDefault(); evidenceInputEngineGallery.click();">Elegir de galería</a> -->
                        </div>
                        <small class="text-muted d-block mt-1">Máximo 4 imágenes ({{(evidencias['engine'] &&
                            evidencias['engine'].length) || 0}}/4)</small>
                    </div>
                </div>
                <div class="row">
                    <ng-container *ngFor="let preview of evidencias['engine']; let i = index">
                        <div class="col-md-3">
                            <div class="thumb-wrapper me-2 mb-2" *ngIf="preview as src">
                                <img [src]="src" alt="preview" class="thumb-image img-thumbnail" />
                                <button type="button" class="thumb-remove-btn" (click)="removeFile(i, 'engine')"
                                    data-bs-toggle="modal" data-bs-target="#confirmRemoveModal" title="Eliminar">
                                    Eliminar evidencia
                                </button>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>

        <!-- Frenos -->
        <div class="card-header d-flex justify-content-between align-items-center">
            <h4 class="mb-0">Frenos</h4>
        </div>
        <div class="card-body row mt-0 mt-0">
            <div class="mb-0 p-3 border rounded">
                <div class="row">
                    <ng-container *ngFor="let campo of [
                        {nombre:'brake_fluid_level', label:'Nivel de líquido de frenos correcto'},
                        {nombre:'brake_pedal', label:'Pedal responde firmemente'},
                        {nombre:'parking_brake', label:'Freno de estacionamiento operativo correcto'},
                        {nombre:'brake_lineLeaks', label:'Sin fugas en líneas de freno'},
                        {nombre:'brake_pump', label:'Compresor de aire en funcionamiento (si aplica)'},
                        {nombre:'brake_no_noise', label:'Sin ruidos anormales al frenar'}
                    ]">
                        <div class="col-md-4 mb-3">
                            <label class="switch-label" for="basic-default-company">{{campo.label}}</label>
                            <div class="input-group input-group-merge">
                                <label class="switch switch-lg">
                                    <input type="checkbox" [(ngModel)]="data[campo.nombre]" class="switch-input"
                                        [name]="campo.nombre" (ngModelChange)="onFormDataChange()" />
                                    <span class="switch-toggle-slider">
                                        <span class="switch-on">
                                            Si
                                        </span>
                                        <span class="switch-off">
                                            No
                                        </span>
                                    </span>
                                    <!-- <span class="switch-label">{{campo.label}}</span> -->
                                </label>
                            </div>
                        </div>
                    </ng-container>
                </div>
                <div class="row">
                    <div class="col">
                        <input type="file" #evidenceInputBrakes multiple class="d-none" accept="image/*" capture="environment"
                            (change)="onFileChange($event, 'brakes')">
                        <input type="file" #evidenceInputBrakesGallery multiple class="d-none" accept="image/*"
                            (change)="onFileChange($event, 'brakes')">
                        <a class="upload_file d-none d-lg-block" (click)="$event.preventDefault(); evidenceInputBrakesGallery.click();">Subir evidencia de todos los frenos</a>
                        <div class="d-flex gap-2 flex-wrap d-lg-none">
                            <a class="upload_file" (click)="$event.preventDefault(); evidenceInputBrakes.click();">Tomar foto</a>
                            <!-- <a class="upload_file" (click)="$event.preventDefault(); evidenceInputBrakesGallery.click();">Elegir de galería</a> -->
                        </div>
                        <small class="text-muted d-block mt-1">Máximo 4 imágenes ({{(evidencias['brakes'] &&
                            evidencias['brakes'].length) || 0}}/4)</small>
                    </div>
                </div>
                <div class="row">
                    <ng-container *ngFor="let preview of evidencias['brakes']; let i = index">
                        <div class="col-md-3">
                            <div class="thumb-wrapper me-2 mb-2" *ngIf="preview as src">
                                <img [src]="src" alt="preview" class="thumb-image img-thumbnail" />
                                <button type="button" class="thumb-remove-btn" (click)="removeFile(i, 'brakes')"
                                    data-bs-toggle="modal" data-bs-target="#confirmRemoveModal" title="Eliminar">
                                    Eliminar evidencia
                                </button>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>

        <!-- Suspensión y dirección -->
        <div class="card-header d-flex justify-content-between align-items-center">
            <h4 class="mb-0">Suspensión y dirección</h4>
        </div>
        <div class="card-body row g-3">
            <div class="mb-0 p-3 border rounded">
                <div class="row">
                    <ng-container *ngFor="let campo of [
                    {nombre:'shock_absorbersLeaks', label:'Amortiguadores sin fugas de aceite'},
                    {nombre:'shock_absorbers_no_jumps', label:'Sin golpeteo en suspensión'},
                    {nombre:'steering_sin_juego', label:'Dirección responde sin juego excesivo'},
                    {nombre:'steering_boxLeaks', label:'Caja de dirección sin fugas'},
                    {nombre:'steering_bushes_in_good_condition', label:'Bujes y terminales en buen estado'}
                ]">
                        <div class="col-md-4 mb-3">
                            <label class="switch-label" for="basic-default-company">{{campo.label}}</label>
                            <div class="input-group input-group-merge">
                                <label class="switch switch-lg">
                                    <input type="checkbox" [(ngModel)]="data[campo.nombre]" class="switch-input"
                                        [name]="campo.nombre" (ngModelChange)="onFormDataChange()" />
                                    <span class="switch-toggle-slider">
                                        <span class="switch-on">
                                            Si
                                        </span>
                                        <span class="switch-off">
                                            No
                                        </span>
                                    </span>
                                </label>
                            </div>
                        </div>
                    </ng-container>
                </div>
                <div class="row">
                    <div class="col">
                        <input type="file" #evidenceInputSuspension multiple class="d-none" accept="image/*" capture="environment"
                            (change)="onFileChange($event, 'suspension')">
                        <input type="file" #evidenceInputSuspensionGallery multiple class="d-none" accept="image/*"
                            (change)="onFileChange($event, 'suspension')">
                        <a class="upload_file d-none d-lg-block" (click)="$event.preventDefault(); evidenceInputSuspensionGallery.click();">Subir evidencia de la suspensión y dirección</a>
                        <div class="d-flex gap-2 flex-wrap d-lg-none">
                            <a class="upload_file" (click)="$event.preventDefault(); evidenceInputSuspension.click();">Tomar foto</a>
                            <!-- <a class="upload_file" (click)="$event.preventDefault(); evidenceInputSuspensionGallery.click();">Elegir de galería</a> -->
                        </div>
                        <small class="text-muted d-block mt-1">Máximo 4 imágenes ({{(evidencias['suspension'] &&
                            evidencias['suspension'].length) || 0}}/4)</small>
                    </div>
                </div>
                <div class="row">
                    <ng-container *ngFor="let preview of evidencias['suspension']; let i = index">
                        <div class="col-md-3">
                            <div class="thumb-wrapper me-2 mb-2" *ngIf="preview as src">
                                <img [src]="src" alt="preview" class="thumb-image img-thumbnail" />
                                <button type="button" class="thumb-remove-btn" (click)="removeFile(i, 'suspension')"
                                    data-bs-toggle="modal" data-bs-target="#confirmRemoveModal" title="Eliminar">
                                    Eliminar evidencia
                                </button>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>

        <!-- Interior y cabina -->
        <div class="card-header d-flex justify-content-between align-items-center">
            <h4 class="mb-0">Interior y cabina</h4>
        </div>
        <div class="card-body row g-3">
            <div class="mb-0 p-3 border rounded">
                <div class="row">
                    <ng-container *ngFor="let campo of [
                        {nombre:'seats_in_good_condition', label:'Asientos en buen estado'},
                        {nombre:'radio', label:'Radio'},
                        {nombre:'seat_belts', label:'Cinturones de seguridad'},
                        {nombre:'air_conditioning', label:'Aire acondicionado'},
                        {nombre:'windows', label:'Vidrios'},
                        {nombre:'locks', label:'Seguros'}
                    ]">
                        <div class="col-md-4 mb-3">
                            <label class="switch-label" for="basic-default-company">{{campo.label}}</label>
                            <div class="input-group input-group-merge">
                                <label class="switch switch-lg">
                                    <input type="checkbox" [(ngModel)]="data[campo.nombre]" class="switch-input"
                                        [name]="campo.nombre" (ngModelChange)="onFormDataChange()" />
                                    <span class="switch-toggle-slider">
                                        <span class="switch-on">
                                            Si
                                        </span>
                                        <span class="switch-off">
                                            No
                                        </span>
                                    </span>
                                </label>
                            </div>
                        </div>
                    </ng-container>
                </div>
                <div class="row">
                    <div class="col">
                        <input type="file" #evidenceInputInteriorAndCabin multiple class="d-none" accept="image/*" capture="environment"
                            (change)="onFileChange($event, 'interior_and_cabin')">
                        <input type="file" #evidenceInputInteriorAndCabinGallery multiple class="d-none" accept="image/*"
                            (change)="onFileChange($event, 'interior_and_cabin')">
                        <a class="upload_file d-none d-lg-block" (click)="$event.preventDefault(); evidenceInputInteriorAndCabinGallery.click();">Subir evidencia del interior</a>
                        <div class="d-flex gap-2 flex-wrap d-lg-none">
                            <a class="upload_file" (click)="$event.preventDefault(); evidenceInputInteriorAndCabin.click();">Tomar foto</a>
                            <!-- <a class="upload_file" (click)="$event.preventDefault(); evidenceInputInteriorAndCabinGallery.click();">Elegir de galería</a> -->
                        </div>
                        <small class="text-muted d-block mt-1">Máximo 4 imágenes ({{(evidencias['interior_and_cabin'] &&
                            evidencias['interior_and_cabin'].length) || 0}}/4)</small>
                    </div>
                </div>
                <div class="row">
                    <ng-container *ngFor="let preview of evidencias['interior_and_cabin']; let i = index">
                        <div class="col-md-3">
                            <div class="thumb-wrapper me-2 mb-2" *ngIf="preview as src">
                                <img [src]="src" alt="preview" class="thumb-image img-thumbnail" />
                                <button type="button" class="thumb-remove-btn"
                                    (click)="removeFile(i, 'interior_and_cabin')" data-bs-toggle="modal"
                                    data-bs-target="#confirmRemoveModal" title="Eliminar">
                                    Eliminar evidencia
                                </button>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>

        <!-- Seguridad y herramientas -->
        <div class="card-header d-flex justify-content-between align-items-center">
            <h4 class="mb-0">Seguridad y herramientas</h4>
        </div>
        <div class="card-body row g-3">
            <div class="mb-0 p-3 border rounded">
                <div class="row">
                    <ng-container *ngFor="let campo of [
                        {nombre:'fire_extinguisher', label:'Extintor de incendio'},
                        {nombre:'hydraulic_jack', label:'Jaque hidráulico'},
                        {nombre:'lug_wrench_or_crosshead_wrench', label:'Llave de llanta'},
                        {nombre:'reflective_triangles', label:'Triangulos reflectivos'},
                    ]">
                        <div class="col-md-4 mb-3">
                            <label class="switch-label" for="basic-default-company">{{campo.label}}</label>
                            <div class="input-group input-group-merge">
                                <label class="switch switch-lg">
                                    <input type="checkbox" [(ngModel)]="data[campo.nombre]" class="switch-input"
                                        [name]="campo.nombre" (ngModelChange)="onFormDataChange()" />
                                    <span class="switch-toggle-slider">
                                        <span class="switch-on">
                                            Si
                                        </span>
                                        <span class="switch-off">
                                            No
                                        </span>
                                    </span>
                                </label>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>

        <!-- Documentación -->
        <div class="card-header d-flex justify-content-between align-items-center">
            <h4 class="mb-0">Documentación</h4>
        </div>
        <div class="card-body row g-3">
            <div class="mb-0 p-3 border rounded">
                <div class="row">
                    <ng-container *ngFor="let campo of [
                        {nombre:'vehicle_registration', label:'Tarjeta de circulación'},
                        {nombre:'current_insurance', label:'Seguro vigente'},
                        {nombre:'vehicle_verification', label:'Verificación vehicular'},
                    ]">
                        <div class="col-md-4 mb-3">
                            <label class="switch-label" for="basic-default-company">{{campo.label}}</label>
                            <div class="input-group input-group-merge">
                                <label class="switch switch-lg">
                                    <input type="checkbox" [(ngModel)]="data[campo.nombre]" class="switch-input"
                                        [name]="campo.nombre" (ngModelChange)="onFormDataChange()" />
                                    <span class="switch-toggle-slider">
                                        <span class="switch-on">
                                            Si
                                        </span>
                                        <span class="switch-off">
                                            No
                                        </span>
                                    </span>
                                </label>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>

        <!-- Kilometraje inicial -->
        <div class="card-header d-flex justify-content-between align-items-center">
            <h4 class="mb-0">Kilometraje inicial</h4>
        </div>
        <div class="card-body row g-3">
            <div class="mb-0 p-3 border rounded">
                <div class="row mb-3">
                    <div class="col-md-4">
                        <label class="switch-label">Fecha</label>
                        <input type="date" class="form-control" [(ngModel)]="data.date" name="date"
                            (ngModelChange)="onFormDataChange()">
                    </div>
                    <div class="col-md-4">
                        <label class="switch-label">Kilometraje inicial</label>
                        <input type="number" class="form-control" placeholder="Ej: 18000 km" [(ngModel)]="data.mileage"
                            name="mileage" (ngModelChange)="onFormDataChange()">
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col">
                        <input type="file" #evidenceInputMileage multiple class="d-none" accept="image/*" capture="environment"
                            (change)="onFileChange($event, 'mileage')">
                        <input type="file" #evidenceInputMileageGallery multiple class="d-none" accept="image/*"
                            (change)="onFileChange($event, 'mileage')">
                        <a class="upload_file d-none d-lg-block" (click)="$event.preventDefault(); evidenceInputMileageGallery.click();">Subir evidencia del kilometraje</a>
                        <div class="d-flex gap-2 flex-wrap d-lg-none">
                            <a class="upload_file" (click)="$event.preventDefault(); evidenceInputMileage.click();">Tomar foto</a>
                            <!-- <a class="upload_file" (click)="$event.preventDefault(); evidenceInputMileageGallery.click();">Elegir de galería</a> -->
                        </div>
                        <small class="text-muted d-block mt-1">Máximo 4 imágenes ({{(evidencias['mileage'] &&
                            evidencias['mileage'].length) || 0}}/4)</small>
                    </div>
                </div>

                <div class="row mb-3">

                    <ng-container *ngFor="let preview of evidencias['mileage']; let i = index">
                        <div class="col-md-3">
                            <div class="thumb-wrapper me-2 mb-2" *ngIf="preview as src">
                                <img [src]="src" alt="preview" class="thumb-image img-thumbnail" />
                                <button type="button" class="thumb-remove-btn" (click)="removeFile(i, 'mileage')"
                                    data-bs-toggle="modal" data-bs-target="#confirmRemoveModal" title="Eliminar">
                                    Eliminar evidencia
                                </button>
                            </div>
                        </div>

                    </ng-container>
                </div>
            </div>
        </div>
        <!-- Evidencias unidad -->
        <div class="card-header d-flex justify-content-between align-items-center">
            <h4 class="mb-0">Evidencias de la unidad</h4>
        </div>
        <div class="card-body row g-3">
            <div class="mb-0 p-3 border rounded">
                <div class="row mb-3">
                    <div class="col-md-4">
                        <input type="file" #evidenceInputFront class="d-none" accept="image/*" capture="environment"
                            (change)="onFileChange($event, 'front')">
                        <input type="file" #evidenceInputFrontGallery class="d-none" accept="image/*"
                            (change)="onFileChange($event, 'front')">
                        <a class="upload_file d-none d-lg-block" (click)="$event.preventDefault(); evidenceInputFrontGallery.click();">Subir evidencia frontal</a>
                        <div class="d-flex gap-2 flex-wrap d-lg-none">
                            <a class="upload_file" (click)="$event.preventDefault(); evidenceInputFront.click();">Tomar foto</a>
                            <!-- <a class="upload_file" (click)="$event.preventDefault(); evidenceInputFrontGallery.click();">Elegir de galería</a> -->
                        </div>
                        <div *ngIf="evidencias['front']?.length" class="mt-2 evidence-previews">
                            <ng-container *ngFor="let preview of evidencias['front']; let i = index">
                                <div class="thumb-wrapper me-2 mb-2" *ngIf="preview as src">
                                    <img [src]="src" alt="preview" class="thumb-image img-thumbnail" />
                                    <button type="button" class="thumb-remove-btn" (click)="removeFile(i, 'front')"
                                        data-bs-toggle="modal" data-bs-target="#confirmRemoveModal" title="Eliminar">
                                        Eliminar evidencia
                                    </button>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <input type="file" #evidenceInputFrontLeft class="d-none" accept="image/*" capture="environment"
                            (change)="onFileChange($event, 'front_left')">
                        <input type="file" #evidenceInputFrontLeftGallery class="d-none" accept="image/*"
                            (change)="onFileChange($event, 'front_left')">
                        <a class="upload_file d-none d-lg-block" (click)="$event.preventDefault(); evidenceInputFrontLeftGallery.click();">Subir evidencia frontal izquierda (3/4)</a>
                        <div class="d-flex gap-2 flex-wrap d-lg-none">
                            <a class="upload_file" (click)="$event.preventDefault(); evidenceInputFrontLeft.click();">Tomar foto frontal izquierda (3/4)</a>
                            <!-- <a class="upload_file" (click)="$event.preventDefault(); evidenceInputFrontLeftGallery.click();">Elegir de galería</a> -->
                        </div>
                        <div *ngIf="evidencias['front_left']?.length" class="mt-2 evidence-previews">
                            <ng-container *ngFor="let preview of evidencias['front_left']; let i = index">
                                <div class="thumb-wrapper me-2 mb-2" *ngIf="preview as src">
                                    <img [src]="src" alt="preview" class="thumb-image img-thumbnail" />
                                    <button type="button" class="thumb-remove-btn" (click)="removeFile(i, 'front_left')"
                                        data-bs-toggle="modal" data-bs-target="#confirmRemoveModal" title="Eliminar">
                                        Eliminar evidencia
                                    </button>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <input type="file" #evidenceInputFrontRight class="d-none" accept="image/*" capture="environment"
                            (change)="onFileChange($event, 'front_right')">
                        <input type="file" #evidenceInputFrontRightGallery class="d-none" accept="image/*"
                            (change)="onFileChange($event, 'front_right')">
                        <a class="upload_file d-none d-lg-block" (click)="$event.preventDefault(); evidenceInputFrontRightGallery.click();">Subir evidencia frontal derecha (3/4)</a>
                        <div class="d-flex gap-2 flex-wrap d-lg-none">
                            <a class="upload_file" (click)="$event.preventDefault(); evidenceInputFrontRight.click();">Tomar foto frontal derecha (3/4)</a>
                            <!-- <a class="upload_file" (click)="$event.preventDefault(); evidenceInputFrontRightGallery.click();">Elegir de galería</a> -->
                        </div>
                        <div *ngIf="evidencias['front_right']?.length" class="mt-2 evidence-previews">
                            <ng-container *ngFor="let preview of evidencias['front_right']; let i = index">
                                <div class="thumb-wrapper me-2 mb-2" *ngIf="preview as src">
                                    <img [src]="src" alt="preview" class="thumb-image img-thumbnail" />
                                    <button type="button" class="thumb-remove-btn"
                                        (click)="removeFile(i, 'front_right')" data-bs-toggle="modal"
                                        data-bs-target="#confirmRemoveModal" title="Eliminar">
                                        Eliminar evidencia
                                    </button>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-md-4">
                        <input type="file" #evidenceInputSideLeft class="d-none" accept="image/*" capture="environment"
                            (change)="onFileChange($event, 'side_left')">
                        <input type="file" #evidenceInputSideLeftGallery class="d-none" accept="image/*"
                            (change)="onFileChange($event, 'side_left')">
                        <a class="upload_file d-none d-lg-block" (click)="$event.preventDefault(); evidenceInputSideLeftGallery.click();">Subir evidencia lateral izquierda</a>
                        <div class="d-flex gap-2 flex-wrap d-lg-none">
                            <a class="upload_file" (click)="$event.preventDefault(); evidenceInputSideLeft.click();">Tomar foto lateral izquierda</a>
                            <!-- <a class="upload_file" (click)="$event.preventDefault(); evidenceInputSideLeftGallery.click();">Elegir de galería</a> -->
                        </div>
                        <div *ngIf="evidencias['side_left']?.length" class="mt-2 evidence-previews">
                            <ng-container *ngFor="let preview of evidencias['side_left']; let i = index">
                                <div class="thumb-wrapper me-2 mb-2" *ngIf="preview as src">
                                    <img [src]="src" alt="preview" class="thumb-image img-thumbnail" />
                                    <button type="button" class="thumb-remove-btn" (click)="removeFile(i, 'side_left')"
                                        data-bs-toggle="modal" data-bs-target="#confirmRemoveModal" title="Eliminar">
                                        Eliminar evidencia
                                    </button>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <input type="file" #evidenceInputSideRight class="d-none" accept="image/*" capture="environment"
                            (change)="onFileChange($event, 'side_right')">
                        <input type="file" #evidenceInputSideRightGallery class="d-none" accept="image/*"
                            (change)="onFileChange($event, 'side_right')">
                        <a class="upload_file d-none d-lg-block" (click)="$event.preventDefault(); evidenceInputSideRightGallery.click();">Subir evidencia lateral derecha</a>
                        <div class="d-flex gap-2 flex-wrap d-lg-none">
                            <a class="upload_file" (click)="$event.preventDefault(); evidenceInputSideRight.click();">Tomar foto lateral derecha</a>
                            <!-- <a class="upload_file" (click)="$event.preventDefault(); evidenceInputSideRightGallery.click();">Elegir de galería</a> -->
                        </div>
                        <div *ngIf="evidencias['side_right']?.length" class="mt-2 evidence-previews">
                            <ng-container *ngFor="let preview of evidencias['side_right']; let i = index">
                                <div class="thumb-wrapper me-2 mb-2" *ngIf="preview as src">
                                    <img [src]="src" alt="preview" class="thumb-image img-thumbnail" />
                                    <button type="button" class="thumb-remove-btn" (click)="removeFile(i, 'side_right')"
                                        data-bs-toggle="modal" data-bs-target="#confirmRemoveModal" title="Eliminar">
                                        Eliminar evidencia
                                    </button>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <input type="file" #evidenceInputFullRear class="d-none" accept="image/*" capture="environment"
                            (change)="onFileChange($event, 'full_rear')">
                        <input type="file" #evidenceInputFullRearGallery class="d-none" accept="image/*"
                            (change)="onFileChange($event, 'full_rear')">
                        <a class="upload_file d-none d-lg-block" (click)="$event.preventDefault(); evidenceInputFullRearGallery.click();">Subir evidencia trasera completa</a>
                        <div class="d-flex gap-2 flex-wrap d-lg-none">
                            <a class="upload_file" (click)="$event.preventDefault(); evidenceInputFullRear.click();">Tomar foto trasera completa</a>
                            <!-- <a class="upload_file" (click)="$event.preventDefault(); evidenceInputFullRearGallery.click();">Elegir de galería</a> -->
                        </div>
                        <div *ngIf="evidencias['full_rear']?.length" class="mt-2 evidence-previews">
                            <ng-container *ngFor="let preview of evidencias['full_rear']; let i = index">
                                <div class="thumb-wrapper me-2 mb-2" *ngIf="preview as src">
                                    <img [src]="src" alt="preview" class="thumb-image img-thumbnail" />
                                    <button type="button" class="thumb-remove-btn" (click)="removeFile(i, 'full_rear')"
                                        data-bs-toggle="modal" data-bs-target="#confirmRemoveModal" title="Eliminar">
                                        Eliminar evidencia
                                    </button>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>

                <div class="row mb-3">
                    <div class="col-md-4">
                        <input type="file" #evidenceInputInside class="d-none" accept="image/*" capture="environment"
                            (change)="onFileChange($event, 'inside')">
                        <input type="file" #evidenceInputInsideGallery class="d-none" accept="image/*"
                            (change)="onFileChange($event, 'inside')">
                        <a class="upload_file d-none d-lg-block" (click)="$event.preventDefault(); evidenceInputInsideGallery.click();">Subir evidencia interior caja</a>
                        <div class="d-flex gap-2 flex-wrap d-lg-none">
                            <a class="upload_file" (click)="$event.preventDefault(); evidenceInputInside.click();">Tomar foto interior caja</a>
                            <!-- <a class="upload_file" (click)="$event.preventDefault(); evidenceInputInsideGallery.click();">Elegir de galería</a> -->
                        </div>
                        <div *ngIf="evidencias['inside']?.length" class="mt-2 evidence-previews">
                            <ng-container *ngFor="let preview of evidencias['inside']; let i = index">
                                <div class="thumb-wrapper me-2 mb-2" *ngIf="preview as src">
                                    <img [src]="src" alt="preview" class="thumb-image img-thumbnail" />
                                    <button type="button" class="thumb-remove-btn" (click)="removeFile(i, 'inside')"
                                        data-bs-toggle="modal" data-bs-target="#confirmRemoveModal" title="Eliminar">
                                        Eliminar evidencia
                                    </button>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Llantas -->
        <div class="card-header d-flex justify-content-between align-items-center">
            <h4 class="mb-0">Llantas</h4>
        </div>
        <div class="card-body row g-3">
            <div class="mb-0 p-3 border rounded">
                <div class="row mb-3">
                    <div class="col">
                        <label class="switch-label">Número de llantas</label>
                        <select class="form-select" [(ngModel)]="data.number_tires" name="number_tires"
                            (ngModelChange)="onNumberTiresChange()">
                            <option selected value="">Seleccionar</option>
                            <option *ngFor="let i of [1,2,3,4,5,6,7,8,9,10,11,12]">{{i}}</option>
                        </select>
                    </div>
                    <div class="col">
                        <label class="switch-label">Número de refacciones</label>
                        <select class="form-select" [(ngModel)]="data.number_repair" name="number_repair"
                            (ngModelChange)="onFormDataChange()">
                            <option selected value="">Seleccionar</option>
                            <option *ngFor="let i of [1,2,3,4,5,6,7,8,9,10,11,12]">{{i}}</option>
                        </select>
                    </div>
                    <div class="col">
                        <ng-container *ngFor="let campo of [
                            {nombre:'repair_optimal', label:'Llantas de refacción en condiciones óptimas'}
                        ]">
                            <div class="col">
                                <label class="switch-label" for="basic-default-company">{{campo.label}}</label>
                                <div class="input-group input-group-merge">
                                    <label class="switch switch-lg">
                                        <input type="checkbox" [(ngModel)]="data[campo.nombre]" class="switch-input"
                                            [name]="campo.nombre" (ngModelChange)="onFormDataChange()" />
                                        <span class="switch-toggle-slider">
                                            <span class="switch-on">
                                                Si
                                            </span>
                                            <span class="switch-off">
                                                No
                                            </span>
                                        </span>
                                    </label>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col">
                        <input type="file" #evidenceInputRepair multiple class="d-none" accept="image/*" capture="environment"
                            (change)="onFileChange($event, 'repair')">
                        <input type="file" #evidenceInputRepairGallery multiple class="d-none" accept="image/*"
                            (change)="onFileChange($event, 'repair')">
                        <a class="upload_file d-none d-lg-block" (click)="$event.preventDefault(); evidenceInputRepairGallery.click();">Subir evidencia de llanta de refacción</a>
                        <div class="d-flex gap-2 flex-wrap d-lg-none">
                            <a class="upload_file" (click)="$event.preventDefault(); evidenceInputRepair.click();">Tomar foto de llanta de refacción</a>
                            <!-- <a class="upload_file" (click)="$event.preventDefault(); evidenceInputRepairGallery.click();">Elegir de galería</a> -->
                        </div>
                        <small class="text-muted d-block mt-1">Máximo 4 imágenes ({{(evidencias['repair'] &&
                            evidencias['repair'].length) || 0}}/4)</small>
                    </div>
                </div>
                <div class="row mb-3">
                    <ng-container *ngFor="let preview of evidencias['repair']; let i = index">
                        <div class="col-md-3">
                            <div class="thumb-wrapper me-2 mb-2" *ngIf="preview as src">
                                <img [src]="src" alt="preview" class="thumb-image img-thumbnail" />
                                <button type="button" class="thumb-remove-btn" (click)="removeFile(i, 'repair')"
                                    data-bs-toggle="modal" data-bs-target="#confirmRemoveModal" title="Eliminar">
                                    Eliminar evidencia
                                </button>
                            </div>
                        </div>
                    </ng-container>
                </div>
                <hr>
                <div *ngFor="let tire of tires; let a = index">
                    <h5>Llanta {{a+1}}</h5>
                    <div class="row mb-3">
                        <div class="col">
                            <label class="switch-label">Marca</label>
                            <input class="form-control" [(ngModel)]="tire.brand" [name]="'brand_'+a"
                                placeholder="Escribe la marca" (ngModelChange)="onFormDataChange()">
                        </div>
                        <div class="col">
                            <label class="switch-label">Modelo</label>
                            <input class="form-control" [(ngModel)]="tire.model" [name]="'model_'+a"
                                placeholder="Escribe el modelo" (ngModelChange)="onFormDataChange()">
                        </div>
                        <div class="col">
                            <label class="switch-label">DOT / Serie de fabricación</label>
                            <input class="form-control" [(ngModel)]="tire.dot" [name]="'dot_'+a"
                                placeholder="Escribe el DOT" (ngModelChange)="onFormDataChange()">
                        </div>
                    </div>
                    <div class="row mb-3">
                        <ng-container *ngFor="let campo of [
                        {nombre:'pressure_correct', label:'Presión correcta'},
                        {nombre:'tire_no_punctures', label:'Sin ponchaduras, cortes o desgaste excesivo'},
                        {nombre:'tire_complete', label:'Birlos completos y firmes'},
                    ]">
                            <div class="col">
                                <label class="switch-label" for="basic-default-company">{{campo.label}}</label>
                                <div class="input-group input-group-merge">
                                    <label class="switch switch-lg">
                                        <input type="checkbox" [(ngModel)]="tire[campo.nombre]" class="switch-input"
                                            [name]="campo.nombre+'_'+a" (ngModelChange)="onFormDataChange()" />
                                        <span class="switch-toggle-slider">
                                            <span class="switch-on">
                                                Si
                                            </span>
                                            <span class="switch-off">
                                                No
                                            </span>
                                        </span>
                                    </label>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                    <div class="row mb-3">
                        <div class="col">
                            <label class="switch-label">Kilometraje inicial al colocar la llanta</label>
                            <input class="form-control" [(ngModel)]="tire.mileage" [name]="'mileage_'+a"
                                placeholder="Ej: 20000 km" (ngModelChange)="onFormDataChange()">
                        </div>
                        <div class="col">
                            <label class="switch-label">Eje</label>
                            <select class="form-select" [(ngModel)]="tire.axis" [name]="'axis_'+a"
                                (ngModelChange)="onFormDataChange()">
                                <option value="">Seleccionar</option>
                                <option *ngFor="let i of [1,2,3]">{{i}}</option>
                            </select>
                        </div>
                        <div class="col">
                            <label class="switch-label">Posición</label>
                            <select class="form-select" [(ngModel)]="tire.position" [name]="'position_'+a"
                                (ngModelChange)="onFormDataChange()">
                                <option value="">Seleccionar</option>
                                <option *ngFor="let i of getFilteredPositions(tire.axis)">
                                    {{i}}</option>
                            </select>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col">
                            <label class="switch-label">Presión</label>
                            <input class="form-control" type="number" [(ngModel)]="tire.pressure" [name]="'pressure_'+a"
                                placeholder="Ej: 80 PSI" (ngModelChange)="onFormDataChange()">
                        </div>
                        <div class="col">
                            <label class="switch-label">Milímetros</label>
                            <input class="form-control" type="number" [(ngModel)]="tire.millimeters"
                                [name]="'millimeters_'+a" placeholder="Ej: 8 mm" (ngModelChange)="onFormDataChange()">
                        </div>
                        <div class="col">
                            <label class="switch-label"></label>
                        </div>
                    </div>

                    <div class="row mb-3">
                        <div class="col">
                            <input type="file" #evidenceInputTires class="d-none" accept="image/*" capture="environment"
                                (change)="onFileChange($event, 'tires_'+(a+1))">
                            <input type="file" #evidenceInputTiresGallery class="d-none" accept="image/*"
                                (change)="onFileChange($event, 'tires_'+(a+1))">
                            <a class="upload_file d-none d-lg-block" (click)="$event.preventDefault(); evidenceInputTiresGallery.click();">Subir evidencia de llanta {{a+1}}</a>
                            <div class="d-flex gap-2 flex-wrap d-lg-none">
                                <a class="upload_file" (click)="$event.preventDefault(); evidenceInputTires.click();">Tomar foto de llanta {{a+1}}</a>
                                <!-- <a class="upload_file" (click)="$event.preventDefault(); evidenceInputTiresGallery.click();">Elegir de galería</a> -->
                            </div>
                            <small class="text-muted d-block mt-1">Máximo 4 imágenes ({{(evidencias['tires_'+(a+1)] &&
                            evidencias['tires_'+(a+1)].length) || 0}}/4)</small>
                        </div>
                    </div>
                    <div class="row mb-3">
                        <ng-container *ngFor="let preview of evidencias['tires_'+(a+1)]; let i = index">
                            <div class="col-md-3">
                                <div class="thumb-wrapper me-2 mb-2" *ngIf="preview as src">
                                    <img [src]="src" alt="preview" class="thumb-image img-thumbnail" />
                                    <button type="button" class="thumb-remove-btn"
                                        (click)="removeFile(i, 'tires_'+(a+1))" data-bs-toggle="modal"
                                        data-bs-target="#confirmRemoveModal" title="Eliminar">
                                            Eliminar evidencia
                                        </button>
                                    </div>
                                </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>

        <!-- Local Storage Controls -->
        <div class="row mb-3">
            <div class="col-12">
                <div class="alert alert-info">
                    <i class="fas fa-info-circle"></i>
                    <strong>&nbsp;Guardado automático por unidad:</strong> Los datos se guardan automáticamente para la
                    unidad <strong>{{unit.unit}}</strong> ({{unit.plates}}) mientras trabajas.
                    Si cierras el navegador, podrás continuar donde lo dejaste para esta unidad específica.
                </div>
            </div>
        </div>

        <div class="text-end">
            <!-- <button type="button" class="btn btn-secondary me-2" (click)="saveToLocalStorage()">
                <i class="fas fa-save"></i> Guardar Progreso
            </button>
            <button type="button" class="btn btn-warning me-2" (click)="clearLocalStorage()">
                <i class="fas fa-trash"></i> Limpiar Datos Guardados
            </button> -->
            <button type="submit" class="btn btn-primary">
                Crear Checklist
            </button>
        </div>
    </form>
</div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.7)" size="medium" color="#fff" type="ball-atom">
    <div class="loader"></div>
    <p style="font-size: 20px; color: white">Espere un momento...</p>
</ngx-spinner>